export default function Switch(theme) {
    return {
        MuiSwitch: {
            styleOverrides: {
                root: {
                    minWidth: 72,
                    height: 40,
                    minHeight: 40,
                    padding: '8px 12px', // 自定義根樣式
                    '& .MuiSwitch-switchBase': {
                        transform: 'translateX(4px)',
                        '&.Mui-checked': {
                            transform: 'translateX(28px)',
                            color: theme.palette.common.white,
                            '& + .MuiSwitch-track': {
                                backgroundColor: theme.palette.primary.main,
                                opacity: 1,
                            },
                        },
                    },
                },
                track: {
                    borderRadius: 99, // 自定義 track 的圓角
                },
                thumb: {
                    width: 22, // 自定義 thumb 的寬度
                    height: 22, // 自定義 thumb 的高度
                    // boxShadow: 'none', // 移除默認陰影
                    // backgroundColor: theme.palette.common.white, // 自定義 thumb 的背景顏色
                },
            },
        },
    };
}